import Component from '@glimmer/component';

import type { KioskDemoPage } from '../../provider/component';

export default class WelcomePage extends Component<KioskDemoPage> {}
